<template>
  <div class="c-menuAccount">
    <h2 class="c-menuAccount_title">{{ username }}</h2>

    <div class="c-menuAccount_card">
      <nav class="m-menuList m-menuList--borderless">
        <div class="m-menuList_item" :class="itemStyle(index, userMenu.shared)" :target="itemTarget(item, userMenu.shared)" v-for="(item, index) in userMenu.shared" :key="index">
          <component :is="getMenuItem(item.type)" :data="item" :display-selected="true" :display-expanded="true" />
        </div>
      </nav>
    </div>

    <h2 class="c-menuAccount_title" v-if="company.isActive">
      {{ company.name }}
    </h2>

    <div class="c-menuAccount_card" v-if="company.isActive">
      <nav class="m-menuList m-menuList--borderless">
        <div class="m-menuList_item" :class="itemStyle(index, companyMenu.shared)" :target="itemTarget(item, companyMenu.shared)" v-for="(item, index) in companyMenu.shared" :key="index">
          <component :is="getMenuItem(item.type)" :data="item" :display-selected="true" :display-expanded="true"/>
        </div>
      </nav>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState, mapGetters } from 'vuex'
import { companyMenu, userMenu } from 'Services/navigationMenu'
import { account } from 'routes'
const itemLink = () => import('Components/Menu/Item/itemLink.vue')
const itemPopup = () => import('Components/Menu/Item/itemPopup.vue')
const itemSubmenu = () => import('Components/Menu/Item/itemSubmenu.vue')
import { StoreState } from 'Types'

const initialState = () => ({
  companyMenu,
  userMenu,
  account,
})

export default {
  components: {
    itemLink,
    itemPopup,
    itemSubmenu,
  },

  data () {
    return initialState()
  },

  computed: {
    ...mapState({
      company: (state: StoreState) => state.account.company,
      status: (state: StoreState) => state.companyAccount.subscription.status,

    }),

    ...mapGetters({
      username: 'account/userFancyName',
    }),
  },

  methods: {
    itemStyle(index: number, list: any[]): string {
      return list.length === index + 1
        ? 'm-menuList_item--last'
        : ''
    },

    itemTarget(index: number, list: any[]): string {
      return list.length === index + 1
        ? '_blank'
        : '_self'
    },

    getMenuItem(type) {
      const getComponent = (type: string) => ({
        'link': itemLink,
        'popup': itemPopup,
        'submenu': itemSubmenu,
      }[type])

      return getComponent(type) || null
    },
  }
}
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/box";

.c-menuAccount{
  width: 100%;

  &_title{
    font-family: $v-fontFamily-brand;
    letter-spacing: $v-fontSpacing-brand;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 18px;
  }

  &_card {
    @extend .m-box;
    padding: 0;
    margin-bottom: 36px;
    overflow: hidden;
  }

  &_button {
    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 55px;
    width: 100%;
    text-decoration: none;
    color: $v-colorDark-secondary;
    fill: $v-colorDark-secondary;
    font-size: 16px;
    transition: .3s background-color ease-in-out;
    background-color: $v-colorWhite;
    box-sizing: border-box;
    padding: 0 $v-gap-sm;
    cursor: pointer;

    &::before {
      content: '';
      display: block;
      width: 18px;
      height: 18px;
      background: no-repeat;
      background-size: contain / center;
      background-image: url('~icon/custom/menu-chevron-down.svg');
      background-position-y: 60%;
      flex-shrink: 0;
      order: 1;
      margin-left: auto;
    }

    &[aria-expanded] {
      background-color: $v-colorGray-light-4;

      &::before {
        background-size: 15px 15px;
        background-image: url('~icon/custom/menu-chevron-up.svg');
      }
    }
  }


  &_link {
    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 55px;
    width: 100%;
    text-decoration: none;
    color: $v-colorDark-secondary;
    fill: $v-colorDark-secondary;
    font-size: 16px;
    transition: .3s background-color ease-in-out;
    background-color: $v-colorWhite;
    box-sizing: border-box;
    padding: 0 $v-gap-sm;

    &:hover, &:active {
      background-color: $v-colorYellow-light-1;
    }

    &--inner {
      padding-left: $v-gap-lg;
    }

    &--selected {
      background-color: $v-colorYellow-light-2;
      color: $v-colorDark-primary;
      fill: $v-colorDark-primary;
    }
  }

  &_icon {
    width: 22px;
    height: 22px;
    margin-right: $v-gap-xs;
  }
}
</style>